/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationResourceScopeBase {
    getFixupPrototypeFunction() { return RecommendationResourceScopeBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationResourceScopeBase>): RecommendationResourceScopeBase {
        let obj = Object.assign(new RecommendationResourceScopeBase(), model);
        RecommendationResourceScopeBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationResourceScopeBase>): RecommendationResourceScopeBase {
        if (!model) return null;
        return RecommendationResourceScopeBase.newInstance(<RecommendationResourceScopeBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationResourceScopeBase) {
        if (!obj) return;

        models.RecommendationResourceScopeBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationResourceScopeBase): boolean {
        Object.setPrototypeOf(obj, RecommendationResourceScopeBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * List of tenant IDs to which the recommendation rule is applied.
     */
    tenant_ids: Array<string>;

    /**
     * Cloud Provider to select
     */
    service_name: models.CloudServiceName;

    /**
     * List of service account IDs to which the recommendation rule is applied.
     */
    service_account_ids: Array<string>;

    /**
     * Query based on Resource Group, Region, resource_id, resource_name and resource
     */
    filters: models.QueryOperator;

}
